/**
 * Created by roman.kupin on 10/3/2017.
 */

import * as AudiencesActions from "../actions/index";
import * as AudiencesApi from "../../../../../actions/api/audiencesApi";

export default function audiencesReducer(state = {
    isInitialized: false
}, {type, payload}) {

    switch (type) {
        case AudiencesActions.INITIALIZED: {
            return Object.assign({}, state, {isInitialized: payload});
        }
        case AudiencesActions.UPCOMING_CONTESTS_FETCH_SUCCESS: {
            return Object.assign({}, state, {upcomingContests: payload});
        }
        case AudiencesActions.PAST_CONTESTS_FETCH_SUCCESS: {
            return Object.assign({}, state, {pastContests: payload});
        }
        case AudiencesApi.GUESTS_FRIENDS_FETCH_SUCCESS: {
            return Object.assign({}, state, { guestsAndFriends: payload });
        }
        case AudiencesApi.VISITORS_FETCH_SUCCESS: {
            return Object.assign({}, state, { visitors: payload });
        }
        case AudiencesApi.WEDDINGS_FETCH_SUCCESS: {
            return Object.assign({}, state, { weddings: payload });
        }
        case AudiencesApi.TEAM_FETCH_SUCCESS: {
            return Object.assign({}, state, { team: payload });
        }
        case AudiencesApi.RANDOM_PHOTOS_FETCH_SUCCESS: {
            return Object.assign({}, state, { randomPhotos: payload });
        }
        case AudiencesApi.SEASONAL_PHOTOS_FETCH_SUCCESS: {
            return Object.assign({}, state, { seasonalPhotos: payload });
        }
        case AudiencesApi.CURRENT_PHOTOS_FETCH_SUCCESS: {
            return Object.assign({}, state, { currentCampaignPhotos: payload });
        }
        default: {
            return state;
        }
    }
}